import { forwardRef } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { fr } from "date-fns/locale/fr";
import "react-datepicker/dist/react-datepicker.css";
import "./ChakraDatePicker.css";
import { Input, Box, IconButton, Flex, Button } from "@chakra-ui/react";
import { LuCalendar, LuChevronLeft, LuChevronRight } from "react-icons/lu";

registerLocale("fr", fr);

const ChakraInput = forwardRef(({ value, onClick, placeholder }, ref) => (
  <Box position="relative" width="100%">
    <Input
      ref={ref}
      value={value}
      onClick={onClick}
      placeholder={placeholder}
      readOnly
      cursor="pointer"
      paddingRight="2.5rem"
    />
    <Box
      position="absolute"
      right="0.75rem"
      top="50%"
      transform="translateY(-50%)"
      pointerEvents="none"
      color="fg.muted"
    >
      <LuCalendar />
    </Box>
  </Box>
));

ChakraInput.displayName = "ChakraInput";

function shiftDate(date, range, direction) {
  const result = new Date(date);
  if (range === "w") {
    result.setDate(result.getDate() + 7 * direction);
  } else if (range === "m") {
    result.setMonth(result.getMonth() + direction);
    result.setDate(1);
  } else if (range === "y") {
    result.setFullYear(result.getFullYear() + direction);
    result.setMonth(0);
    result.setDate(1);
  } else {
    result.setDate(result.getDate() + direction);
  }
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  return result > today ? new Date() : result;
}

function isToday(date) {
  const today = new Date();
  return date.getFullYear() === today.getFullYear()
    && date.getMonth() === today.getMonth()
    && date.getDate() === today.getDate();
}

export default function ChakraDatePicker({ selected, onChange, range, ...props }) {
  const today = new Date();

  return (
    <Flex align="center" gap="1">
      <IconButton
        aria-label="Précédent"
        size="sm"
        variant="ghost"
        onClick={() => selected && onChange(shiftDate(selected, range, -1))}
      >
        <LuChevronLeft />
      </IconButton>
      <DatePicker
        selected={selected}
        onChange={onChange}
        maxDate={today}
        locale="fr"
        dateFormat="dd MMMM yyyy"
        customInput={<ChakraInput />}
        calendarClassName="chakra-datepicker"
        popperClassName="chakra-datepicker-popper"
        {...props}
      />
      <IconButton
        aria-label="Suivant"
        size="sm"
        variant="ghost"
        disabled={selected && isToday(selected)}
        onClick={() => selected && onChange(shiftDate(selected, range, 1))}
      >
        <LuChevronRight />
      </IconButton>
      <Button
        size="sm"
        variant="outline"
        disabled={selected && isToday(selected)}
        onClick={() => onChange(new Date())}
      >
        Aujourd'hui
      </Button>
    </Flex>
  );
}
